<i18n lang="json">
{
  "en": {
    "home": "Home"
  },
  "fr": {
    "home": "Accueil"
  }
}
</i18n>

<template>
  <nav class="flex overflow-hidden" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center gap-1">
      <li>
        <a :href="getLocalePath({ name: 'index' })" class="text-gray-400 hover:text-highlight">
          <HomeIcon class="size-5 flex-shrink-0" aria-hidden="true" />
          <span class="sr-only">{{ t('home') }}</span>
        </a>
      </li>
      <li v-for="(item, index) in items" :key="item.name" class="flex items-center">
        <ChevronRightIcon class="size-5 flex-shrink-0 text-gray-400" aria-hidden="true" />

        <NuxtLink
          v-if="index < items.length - 1"
          :href="item.href"
          :title="item.name"
          class="ml-1 text-sm font-medium text-gray-500 whitespace-nowrap text-ellipsis overflow-hidden hover:text-highlight-700"
          :aria-current="index == items.length - 1 ? 'page' : undefined"
        >
          {{ item.name }}
        </NuxtLink>

        <div
          class="ml-1 text-sm font-medium text-primary whitespace-nowrap text-ellipsis overflow-hidden"
          :title="item.name"
          v-else
        >
          {{ item.name }}
        </div>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import { ChevronRightIcon, HomeIcon } from '@heroicons/vue/20/solid'
import type { MenuItem } from '~/types/components/menu-item'

const { t, locale } = useI18n()
const $config = useRuntimeConfig()

const props = defineProps<{
  items: MenuItem[]
}>()

useJsonld(() => {
  const entries = props.items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 2,
    name: item.name,
    item: `${$config.public.app.marketplace.webUrl}${item.href}`
  }))

  entries.unshift({
    '@type': 'ListItem',
    position: 1,
    name: t('home'),
    item: `${$config.public.app.marketplace.webUrl}/${locale.value}`
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: entries as unknown as any
  }
})
</script>
